import React from 'react';
import clsx from 'clsx';
import styles from './submitButton.module.css';
import { CircularProgress } from '@material-ui/core';

const SubmitButton = ({
  text,
  disable,
  onClick,
  loading,
  width,
  className,
  textClassName,
  textStyle,
  buttonStyle,
}) => {
  return (
    <button
      type="button"
      className={clsx(
        styles.container,
        disable ? styles.disabled : '',
        className
      )}
      onClick={!disable ? onClick : undefined}
      disabled={disable}
      style={{ width: width, ...buttonStyle }}>
      {loading ? (
        <CircularProgress size={16} />
      ) : (
        <span className={clsx(styles.text, textClassName)} style={textStyle}>
          {text}
        </span>
      )}
    </button>
  );
};

export default SubmitButton;

